module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Crowning Glory")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#foreword"
    }
  }, [_vm._v("Foreword")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#william-i-1066-1087"
    }
  }, [_vm._v("William I (1066-1087)")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#william-ii-1087-1100"
    }
  }, [_vm._v("William II (1087-1100)")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#henry-i-1100-1135"
    }
  }, [_vm._v("Henry I (1100-1135)")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#stephen-1135-1154"
    }
  }, [_vm._v("Stephen (1135-1154)")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#matilda-april-november-1141"
    }
  }, [_vm._v("Matilda (April-November 1141)")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch010#henry-ii-1154-1189"
    }
  }, [_vm._v("Henry II (1154-1189)")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch011#richard-i-1189-1199"
    }
  }, [_vm._v("Richard I (1189-1199)")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#john-1199-1216",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John (1199-1216)")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#henry-iii-1216-1272",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Henry III (1216-1272)")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#edward-i-1272-1307",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edward I (1272-1307)")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#edward-ii-1307-1327",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edward II (1307-1327)")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#edward-iii-1327-1377",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edward III (1327-1377)")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#richard-ii-1377-1399",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Richard II (1377-1399)")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#henry-iv-1399-1413",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Henry IV (1399-1413)")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#henry-v-1413-1422",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Henry V (1413-1422)")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#henry-vi-1422-61-and-1470-71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Henry VI (1422-61 and 1470-71)")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#edward-iv-1461-70-and-1471-83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edward IV (1461-70 and 1471-83)")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#edward-v-1483",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edward V (1483)")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#richard-iii-1483-1485",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Richard III (1483-1485)")])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#henry-vii-1485-1509",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Henry VII (1485-1509)")])]), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#henry-viii-1509-1547",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Henry VIII (1509-1547)")])]), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#edward-vi-1547-1553",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edward VI (1547-1553)")])]), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#jane-nine-days-1553",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jane (Nine Days 1553)")])]), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#mary-i-1553-1558",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mary I (1553-1558)")])]), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#elizabeth-i-1558-1603",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Elizabeth I (1558-1603)")])]), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#james-i-1603-1625",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("James I (1603-1625)")])]), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#charles-i-1625-1649",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Charles I (1625-1649)")])]), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#the-interregnum-1649-1660",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Interregnum (1649-1660)")])]), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#charles-ii-1660-1685",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Charles II (1660-1685)")])]), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#james-ii-1685-1689",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("James II (1685-1689)")])]), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#william-iii-and-mary-ii-together-1689-94-william-alone-1694-1702",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("William III and Mary II (Together: 1689-94, William alone: 1694-1702)")])]), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#anne-1702-1714",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Anne (1702-1714)")])]), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#george-i-1714-1727",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("George I (1714-1727)")])]), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#george-ii-1727-1760",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("George II (1727-1760)")])]), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch039#george-iii-1760-1820",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("George III (1760-1820)")])]), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch040#george-iv-1820-1830",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("George IV (1820-1830)")])]), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch041#william-iv-1830-1837",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("William IV (1830-1837)")])]), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch042#victoria-1837-1901",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Victoria (1837-1901)")])]), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch043#edward-vii-1901-1910",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edward VII (1901-1910)")])]), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch044#george-v-1910-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("George V (1910-36)")])]), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch045#edward-viii-1936",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edward VIII (1936)")])]), _c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch046#george-vi-1936-1952",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("George VI (1936-1952)")])]), _c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch047#elizabeth-ii-1952-2022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Elizabeth II (1952-2022)")])]), _c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch048#charles-iii-2022-present",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Charles III (2022-present)")])]), _c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#the-british-crown-jewels",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The British Crown Jewels")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#introduction",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#st-edwards-crown",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("St Edward’s Crown")])]), _c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#the-imperial-state-crown",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Imperial State Crown")])]), _c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#edward-the-confessors-sapphire",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edward the Confessor’s Sapphire")])]), _c('li', {
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#the-black-princes-ruby",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Black Prince’s Ruby")])]), _c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#the-second-star-of-africa",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Second Star of Africa")])]), _c('li', {
    attrs: {
      "id": "toc-li-56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#the-stuart-sapphire",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Stuart Sapphire")])]), _c('li', {
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#queen-elizabeths-earrings",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Queen Elizabeth’s Earrings")])]), _c('li', {
    attrs: {
      "id": "toc-li-58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#the-imperial-crown-of-india",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Imperial Crown of India")])]), _c('li', {
    attrs: {
      "id": "toc-li-59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#the-crown-of-queen-mary-consort-of-king-george-v",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Crown of Queen Mary, Consort of King George V")])]), _c('li', {
    attrs: {
      "id": "toc-li-60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#the-crown-of-the-queen-mother-queen-elizabeth-consort-of-king-george-vi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Crown of the Queen Mother, Queen Elizabeth (consort of King George VI)")])]), _c('li', {
    attrs: {
      "id": "toc-li-61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#the-crown-of-queen-aleksandra-consort-of-king-edward-vii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Crown of Queen Aleksandra, Consort of King Edward VII")])]), _c('li', {
    attrs: {
      "id": "toc-li-62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#the-small-diamond-crown-of-queen-victoria",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Small Diamond Crown of Queen Victoria")])]), _c('li', {
    attrs: {
      "id": "toc-li-63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#the-crown-of-mary-of-modena",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Crown of Mary of Modena")])]), _c('li', {
    attrs: {
      "id": "toc-li-64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#the-honours-of-the-principality-of-wales",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Honours of the Principality of Wales")])]), _c('li', {
    attrs: {
      "id": "toc-li-65"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#the-coronet-of-prince-george-the-future-king-george-v",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The coronet of Prince George (the future King George V)")])]), _c('li', {
    attrs: {
      "id": "toc-li-66"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#the-coronet-of-prince-charles-currently-king-charles-iii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The coronet of Prince Charles (currently King Charles III)")])]), _c('li', {
    attrs: {
      "id": "toc-li-67"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#royal-sceptres",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Royal Sceptres")])]), _c('li', {
    attrs: {
      "id": "toc-li-68"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#orbs",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Orbs:")])]), _c('li', {
    attrs: {
      "id": "toc-li-69"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#the-anointing-spoon-and-ampulla",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Anointing Spoon and Ampulla")])]), _c('li', {
    attrs: {
      "id": "toc-li-70"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#spurs-armills-and-rings",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spurs, Armills and Rings")])]), _c('li', {
    attrs: {
      "id": "toc-li-71"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#the-golden-spurs-of-st-george",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Golden Spurs of St George")])]), _c('li', {
    attrs: {
      "id": "toc-li-72"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#armills",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Armills")])]), _c('li', {
    attrs: {
      "id": "toc-li-73"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#coronation-rings",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coronation Rings")])]), _c('li', {
    attrs: {
      "id": "toc-li-74"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#the-diamond-diadem",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Diamond Diadem")])]), _c('li', {
    attrs: {
      "id": "toc-li-75"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#sword-of-state",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sword of State")])]), _c('li', {
    attrs: {
      "id": "toc-li-76"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#the-jewelled-state-sword-of-offering",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Jewelled State Sword of Offering")])]), _c('li', {
    attrs: {
      "id": "toc-li-77"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#the-swords-spiritual-temporal-and-mercy-curtana",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Swords Spiritual, Temporal and Mercy (Curtana)")])]), _c('li', {
    attrs: {
      "id": "toc-li-78"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#the-irish-sword-of-state",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Irish Sword of State")])]), _c('li', {
    attrs: {
      "id": "toc-li-79"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#tiaras",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tiaras")])]), _c('li', {
    attrs: {
      "id": "toc-li-80"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#the-girls-of-great-britain-and-ireland-tiara",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Girls of Great Britain and Ireland Tiara")])]), _c('li', {
    attrs: {
      "id": "toc-li-81"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#the-greville-tiara",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Greville Tiara")])]), _c('li', {
    attrs: {
      "id": "toc-li-82"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#the-grand-duchess-vladimir-tiara",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Grand Duchess Vladimir Tiara")])]), _c('li', {
    attrs: {
      "id": "toc-li-83"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#the-cambridge-lovers-knot-tiara",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Cambridge Lover’s Knot Tiara")])]), _c('li', {
    attrs: {
      "id": "toc-li-84"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#the-fringe-tiara",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fringe Tiara")])]), _c('li', {
    attrs: {
      "id": "toc-li-85"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#queen-alexandras-kokoshnik-tiara",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Queen Alexandra’s Kokoshnik Tiara")])]), _c('li', {
    attrs: {
      "id": "toc-li-86"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#the-meander-tiara",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Meander Tiara")])]), _c('li', {
    attrs: {
      "id": "toc-li-87"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#the-cartier-halo-tiara",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Cartier Halo Tiara")])]), _c('li', {
    attrs: {
      "id": "toc-li-88"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#the-honours-of-scotland",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Honours of Scotland")])]), _c('li', {
    attrs: {
      "id": "toc-li-89"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#the-tudor-crown",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Tudor Crown")])]), _c('li', {
    attrs: {
      "id": "toc-li-90"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#the-theft-of-the-crown-jewels",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Theft of the Crown Jewels")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-917484e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0